<template lang="pug">
div(v-if="ready")
	b-modal(id="print-article-modal" centered :hide-footer="true" :hide-header="true" ref="printArticleModal")
		b-row.hero-modal-wrapper(v-if="hero")
			b-col.no-gutter(md="12" sm="12")
				.hero-modal(v-if="hero")
					b-img-lazy(:src="hero")
		b-row
			.close(@click="hideModal()") CLOSE
			b-col(md="12" sm="12")
				.unlock-header
					h2 Unlock Printing
					p
						| Already have an account?
						| &nbsp;
						a(href="/login")
							| Log in
			b-col(md="12" sm="12")
				b-row
					b-col
						.tb.tbs
							label(for="print-article-type-of-user")
								select(id="print-article-type-of-user" v-model="typeOfUser" @change="validateForm()")
									option(value="" disabled="disabled") I am a ...
									option(value="parent") Parent
									option(value="grandparent") Grandparent
									option(value="advisor") Financial Advisor
									option(value="other") Other
								span.error(v-if="typeOfUserError")
									| {{typeOfUserErrorMessage}}
								span.floaty-label(:class="{'show-floaty' : userFloaty }") I am a ...
							span.arrow-down
				b-row
					b-col
						.tb.tbs
							label(for="print-article-state-of-residence")
								select(id="print-article-state-of-residence" v-model="stateOfResidence" @change="validateForm()")
									option(value="" disabled="disabled") State of residence
									option(v-for="state of states" :value="state.id")
										| {{state.name}}
								span.error(v-if="stateOfResidenceError")
									| {{stateOfResidenceErrorMessage}}
								span.floaty-label(:class="{'show-floaty' : stateFloaty }") State of residence
							span.arrow-down
				b-row
					b-col
						.tb
							label(:class="{'not-empty': !email == '' }" for="print-article-email")
								input(id="print-article-email" v-model="email" type="text" placeholder="Your email address" @input="validateForm()")
								span.floaty-label(:class="{'show-floaty' : emailFloaty }") Your email address
								span.error(v-if="emailError")
									| {{emailErrorMessage}}
				b-row
					b-col
						a.btn.sfc-blue(@click="submit($event)") Print
</template>

<style lang="stylus">
	#print-article-modal
		.modal-dialog
			max-width: 350px
</style>
<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#print-article-modal
		position: relative

		.hero-modal-wrapper
			margin-top: -30px
			.hero-modal
				margin: -30px
				img
					width: 100% !important
					height: 100% !important
					border-top-left-radius: 0.3rem
					border-top-right-radius: 0.3rem
		.unlock-header
			h2
				text-align: center
				color: body-font-color
				margin-top: 20px
			p
				margin: 0 auto !important
			a
				cursor: pointer
		.close
			text-shadow: none
			position: absolute
			top: -20px
			font-size: body-font-size-md
			color: #fff
			opacity: 0.7
			transition-all()
			right: 0
			font-weight: body-font-weight
			cursor: pointer
			&:hover
				opacity: 1
		.modal-dialog
			max-width: 350px!important
			text-align: center
			.tb
				margin: 0
				label
					margin-bottom: 15px
					input
						&::placeholder
							color: #fff
							opacity: 1
						&:focus
							&::placeholder
								color: #fff
								opacity: 0
							+ span.floaty-label
								top: 20px!important
					.floaty-label
						top: 40px
					&.not-empty
						.floaty-label
							opacity: 1
							top: 20px!important
				&.tbs
					.floaty-label
						top: 5px
						opacity: 0
						transition-all()
						font-size: body-font-size-xs
						&.show-floaty
							opacity: 1
				select
					margin: 15px 0
					margin-bottom: 0
					&:focus
						color: sfc-blue
				input
					margin: 30px 0
					margin-bottom: 0px
					&:focus
						color: sfc-blue

			.modal-content
				border: 1px solid #000
			.modal-body
				box-shadow-modal()
				img
					margin: 30px auto
					width: 100px
					height: 100px
				.col-md-4
					border-right: 1px solid sfc-pale-gray
					&:last-child
						border-right: 0px
				h3
					font-size: body-font-size-lg-plus
					text-align: center

				.sub-h3
					text-align: center
					color: body-font-color
				p
					margin: 30px auto
					text-align: center
					color: body-font-color

				a.btn
					margin: 10px auto 0
					display: block
					font-size: body-font-size-md
					font-weight: body-font-weight-strong
					width: 135px
			select
				background-color: transparent
				font-size: body-font-size-md

				color: body-font-color
				z-index: 10
			label
				z-index: 2

			span.arrow-down
				z-index: 1
</style>

<script>
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {
	data() {
		return {
			email: "",
			stateOfResidence: "",
			typeOfUser: "",
			emailError: false,
			stateOfResidenceError: false,
			typeOfUserError: false,
			emailErrorMessage: "",
			stateOfResidenceErrorMessage: "",
			typeOfUserErrorMessage: "",
			validateOnChange: false,
			ready: true,
			userFloaty: false,
			stateFloaty: false,
			emailFloaty: false,
			states: []
		}
	},
	async created(){
		const query =
			`
			query{
				states_without_territories{
					id
					name
					slug
				}
			}
			`
		const response = await this.$httpService.graphql(query)
		this.states = response.data.states_without_territories
	},

	props: ['hero'],

	methods: {
		hideModal() {
			this.$refs.printArticleModal.hide()
			document.body.classList.remove("modal-open") //just in case
			this.email = ""
			this.stateOfResidence = ""
			this.typeOfUser = ""
			this.emailError = false
			this.stateOfResidenceError = false
			this.typeOfUserError = false
			this.emailErrorMessage = ""
			this.stateOfResidenceErrorMessage = ""
			this.typeOfUserErrorMessage = ""
			this.validateOnChange = false
		},

		validateForm() {

			if (this.typeOfUser != "" && this.typeOfUser != "I am a ...") {
				this.userFloaty = true
			}
			if (this.stateOfResidence != "" && this.stateOfResidence != "State of residence") {
				this.stateFloaty = true
			}
			if (this.validateOnChange) {

				this.emailError = false
				this.stateOfResidenceError = false
				this.typeOfUserError = false
				this.emailErrorMessage = ""
				this.stateOfResidenceErrorMessage = ""
				this.typeOfUserErrorMessage = ""

				const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

				if (!emailRegex.test(this.email)) {
					this.emailError = true
					this.emailErrorMessage = "Please enter a valid email"
				}

				if (!this.stateOfResidence || this.stateOfResidence == "") {
					this.stateOfResidenceError = true
					this.stateFloaty = false
					this.stateOfResidenceErrorMessage = "Please select a state"
				}
				if (!this.typeOfUser || this.typeOfUser == "") {
					this.typeOfUserError = true
					this.userFloaty = false
					this.typeOfUserErrorMessage = "Please select a type of user"
				}
				return !(this.emailError || this.stateOfResidenceError || this.typeOfUserError)
			}

		},

		submit(clickEvent) {
			this.validateOnChange = true
			if (this.validateForm()) {
				this.submitData()
				this.hideModal()
				try {
					document.execCommand('print', false, null);
					window.print();
				}
				catch(e) {
					setTimeout(() => {
						window.print();
					}, 100)
				}
			} else {
				clickEvent.preventDefault()
			}
		},

		async submitData() {
			// Create email capture cookie
			this.$cookies.set('print_article_v2', this.email, {
				path: '/',
				domain: 'savingforcollege.com',
				maxAge: 365 * 24 * 60 * 60
			})

			const query =
				`
				mutation{
					track_data(user_type: "${this.typeOfUser}", state_id: "${this.stateOfResidence}", email: "${this.email}", email_source: "print_article")
				}
				`
			try {
				await this.$httpService.graphql(query)
				this.trackAction('Email Capture - Print Article')
			} catch (e) {
				console.error(e)
			}

		},

		trackAction(eventDescription, additionalInformation = false) {
			SfcTrackingService.trackAction(eventDescription, "Articles", `${this.$store.state.config.articlesPageVersion}`, additionalInformation)
		},
	}
}
</script>
